<template>
    <div>
        <global-spinner/>
        <div class="app-module">
            <router-view></router-view>
        </div>
        <notifications />
    </div>
</template>

<style>
    .app-module {
        position: relative;
        z-index: 2;
    }
</style>

<script>
    import GlobalSpinner from './components/GlobalSpinner/GlobalSpinner.vue';

    export default {
        name: 'app-module',

        components: {
            GlobalSpinner
        },

        data() {
          return {

          }
        },

        mounted() {
        }
    }
</script>
